import { useState } from "react";

/** Small ⓘ hover/focus tooltip for field labels and table headers. */
export default function InfoTip({ text, align = "start", wide = false }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  return (
    <span
      style={styles.wrap}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        style={styles.btn}
        aria-label="Help"
        title={text}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        i
      </button>
      {open ? (
        <span
          role="tooltip"
          style={{
            ...styles.bubble,
            ...(wide ? styles.bubbleWide : null),
            ...(align === "end" ? { right: 0, left: "auto" } : null),
          }}
        >
          {text}
        </span>
      ) : null}
    </span>
  );
}

const styles = {
  wrap: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
  },
  btn: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    border: "1px solid #9ca3af",
    background: "#f3f4f6",
    color: "#4b5563",
    fontSize: 10,
    fontWeight: 700,
    fontStyle: "italic",
    lineHeight: "14px",
    padding: 0,
    cursor: "help",
    flexShrink: 0,
  },
  bubble: {
    position: "absolute",
    left: 0,
    bottom: "calc(100% + 6px)",
    zIndex: 30,
    width: 260,
    padding: "8px 10px",
    borderRadius: 6,
    background: "#111827",
    color: "#f9fafb",
    fontSize: 11,
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: 1.4,
    boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
    pointerEvents: "none",
    whiteSpace: "pre-line",
    textAlign: "left",
  },
  bubbleWide: {
    width: 340,
  },
};
